import Link from 'next/link'
import { FaChevronRight } from  'react-icons/fa'
import styles from './dashboard.module.css'

export default function CardWrapper (props) {
    
    return(
        <>
            <div className={`${props.class}  ${styles.mt9}  position-relative px-3 mb-4`}>
                <p className={`${styles.cardTitle} pl-md-5  position-relative`}>
                    <strong>{props.category}</strong> 
                    { props.isExploreAll == 'true' ? <Link href={props.url} passHref><a className="h7 position-relative exploreAll ml-3"> Explore All <FaChevronRight/></a></Link> : ''} 
                </p>
                {props.children}
            </div>
            <style jsx>
                {`
                    .exploreAll{
                        z-index:3;
                    }
                `}
            </style>
        </>
    )
    
}